import { BackendService, Punch, PunchEntry } from '../service/backend-service';
import { useEffect, useMemo, useState } from 'react';
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import classNames from 'classnames';
import moment from 'moment';
import { useAuth0 } from '@auth0/auth0-react';
import { StyledToast } from '../util/styled-toast';
import { errorMessage } from '../util/error-utils';

const timeFormat = 'YYYY-MM-DDTHH:mm';

function PunchEdit({
  punchEntry,
  onSave,
  extraClasses
}: {
  punchEntry: PunchEntry,
  onSave: (newPunch: PunchEntry) => void,
  extraClasses?: string
}) {
  
  let auth0 = useAuth0();

  const service = useMemo(() => {
    return new BackendService(auth0);
  }, [auth0]);

  const [editing, setEditing] = useState(false);
  const [punchEdited, setPunchEdited] = useState<Punch>(punchEntry);

  useEffect(() => {
    setPunchEdited(punchEntry);
  }, [punchEntry]);

  const closeEditing = () => {
    setEditing(false);
    setPunchEdited(punchEntry);
  };

  const saveChanges = () => {
    service.updatePunch(punchEntry.project, punchEdited)
      .then(newEntry => onSave({
        ...newEntry,
        project: punchEntry.project
      }))
      .then(() => StyledToast.success('Punch updated successfully!'))
      .catch((ex: any) => StyledToast.error(errorMessage(ex)))

    closeEditing();
  };

  return (
    <>
      <i title="Edit Punch" className={classNames("fas fa-fw fa-pen-to-square cursor-pointer", extraClasses)} onClick={() => setEditing(true)}/>
      <Modal isOpen={editing} toggle={closeEditing} size={'lg'} centered>
        <ModalHeader className={'alert-' + punchEntry.project.color} toggle={closeEditing}>Edit punch for <b>{punchEntry.project.name}</b></ModalHeader>
        <ModalBody>
          <div className='row row-cols-2'>
            <div className='col'>
              <div className="form-floating">
                <Input id='start' name='start' placeholder='Start Time' autoFocus type="datetime-local" value={moment(punchEdited.start).format(timeFormat)} 
                      onChange={e => setPunchEdited({
                        ...punchEdited,
                        start: e.target.value === '' ? punchEdited.start : moment(e.target.value).utc().format()
                      })}
                />
                <Label for="start"><i className='fas fa-circle-play me-2 text-primary'/>Start</Label>
              </div>
            </div>
            <div className='col'>
              <div className="form-floating">
                <Input disabled={punchEntry.end === undefined} id='end' name='end' placeholder='End Time' autoFocus type="datetime-local" value={punchEdited.end === undefined ? undefined : moment(punchEdited.end).format(timeFormat)} 
                      onChange={e => setPunchEdited({
                        ...punchEdited,
                        end: e.target.value === '' ? undefined : moment(e.target.value).utc().format()
                      })}
                />
                <Label for="end"><i className='fas fa-circle-stop me-2 text-danger'/>End</Label>
              </div>
            </div>
            <div className='col-md-12'>
              <div className="form-floating mt-3 mb-2">
                <Input placeholder="Work Description" type="textarea" style={{ height: '92px' }} 
                      value={punchEdited.workDescription} 
                      onChange={e => setPunchEdited({
                        ...punchEdited,
                        workDescription: e.target.value
                      })}
                />
                <Label><i className='far fa-fw fa-comment-dots me-2' />Work Description</Label>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className='pt-1 pb-1'>
          <Button size='sm' color={punchEntry.project.color} onClick={saveChanges}>
            Save Changes
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default PunchEdit;
